import { Action } from "@ngrx/store";
import { SideNavState } from "./side-nav.reducer";

export enum SideNavActionTypes {
  SetNavState = "[SideNav] Set State",
  SetExpanded = "[SideNav] Set Expanded",
}

export class SetExpanded implements Action {
  readonly type = SideNavActionTypes.SetExpanded;
  constructor(public expanded: boolean) {}
}

export class SetNavState implements Action {
  readonly type = SideNavActionTypes.SetNavState;
  constructor(public state: SideNavState) {}
}

export type SideNavActions = SetNavState | SetExpanded;
